$(function() {
    /**
    * Disable the button after click
    */
    $('[data-click=disable]').on('click', function () {
        disableButton(this);

        if ($(this).is(':submit')) {
            $(this).closest('form').submit();
        }
    });
});
